/*****************************************************************************/
/*  File Name: itemSelect.js                                                 */
/*  Date:      June 22, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This will handle the item selections of the systems on the
/*             bottom half of the bar
/*
/*****************************************************************************/

import React /* useState,*/ from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import styles from './styles/roi.module.scss';
import { MenuItem, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { useROIContext } from '../../context/roiContext';

import { convertToCurrency } from '../../functions/convertCurrency';
import { useTipContext } from '../../context/tipContext';
import { convertToNumber } from '../../functions/convertNumber';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SoltaSelect from './elements/SelectField';
import TipPriceTextField from './elements/TipPriceField';
import * as TIMERANGE from '../../constants/timeRanges';

function TipSelectGrowth({ t }) {
  //Load all of the default component varaibles

  const { growthTips, setGrowthTips, consumablePriceGrowth, addAnotherTreatmentGrowth, removeTreatmentGrowth, selectedTimeRange, addTipCountGrowth, removeTipCountGrowth } = useROIContext();

  const { tips, tipsLoading } = useTipContext();
  //console.log('This is my grow Tip ---->', growthTips);
  //console.log(" is t not coming through? -> ", t);   //US Dosent use Translations

  return (
    <Grid item xs={12} container className={styles.tipSelectGrid}>
      <Grid item xs={12} container className={styles.tipHeadline} justifyContent='space-between'>
        <Grid item className={styles.title}>
        Extra Treatments
        </Grid>
        <Grid item>
          <Button className={styles.addTreatmentButton} onClick={() => addAnotherTreatmentGrowth()} startIcon={<AddCircleOutlineIcon />}>
          Add another treatment
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={12} container alignItems='flex-end' className={`${styles.tipLine} ${styles.headline}`}>
        <Grid item className={styles.removeGrid}>
          {/* Remove button place holder*/}
        </Grid>
        <Grid item xs className={styles.tipSelectDropDown}>
        Treatment Tip
        </Grid>
        <Grid item xs className={styles.quantityGrid}>
        Treatment per {selectedTimeRange === TIMERANGE.weekly ? 'WEEK' : "MONTH"}
        </Grid>
        <Grid item xs className={`${styles.tipPriceGrid} `}>
        Treatment Price to patient
        </Grid>
        <Grid item className={`${styles.tipPriceGrid} `}>
        Tip Price per Treatment
        </Grid>
        <Grid item xs className={`${styles.tipPriceGrid}`}>
        Other Charges
        </Grid>
      </Grid>
      <Grid item xs={12} container className={styles.tipGroup}>
        {!tipsLoading
          ? growthTips.map((myGrowthTip, i) => (
              <Grid item xs={12} container key={i + 'growth'} alignItems='center' className={styles.tipLine}>
                <Grid item className={styles.removeGrid}>
                  <Tooltip title='Remove Item?'>
                    <IconButton onClick={() => removeTreatmentGrowth(i)} className={styles.removeButton}>
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item xs className={styles.tipSelectDropDown}>
                  <SoltaSelect
                    labelId='grow-tip-select'
                    id='grow-tip-select'
                    value={myGrowthTip.id}
                    onChange={(event) =>
                      setGrowthTips((prevSelectedTips) => {
                        //console.log('this is my previous slected tips ----> ', prevSelectedTips);
                        const updatedSelectedGrowthTips = [...prevSelectedTips]; // Create a new array with the same values as prevSelectedTips

                        //Get all of the tips information
                        const growselectedTip = tips.filter((tip) => tip.id === event.target.value).map((tip) => tip);
                        // Update the second entry's sku value
                        updatedSelectedGrowthTips[i] = growselectedTip[0];
                        updatedSelectedGrowthTips[i].amount = 1; //Set the default quantiy to 1
                        updatedSelectedGrowthTips[i].type = 'growth';
                        return updatedSelectedGrowthTips; // Return the updated array as the new state
                      })
                    }
                  >
                    {tips.map((tip) => (
                      <MenuItem value={tip.id} key={tip.id}>
                        <Typography className={styles.tipName}>{tip.sku}</Typography>
                      </MenuItem>
                    ))}
                  </SoltaSelect>
                </Grid>
                <Grid item xs container alignItems='center' className={styles.quantityGrid}>
                  <Grid item xs className={styles.quantityButtons}>
                    <Tooltip title='Subtract Quantity'>
                      <span>
                        <IconButton disabled={!myGrowthTip.id || convertToNumber(myGrowthTip.amount ?? 0) <= 1} className={styles.quantityButton} onClick={() => removeTipCountGrowth(i)}>
                          <RemoveCircleOutlineIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Grid>
                  <Grid item xs className={styles.quantityField}>
                    <TipPriceTextField
                      disabled={!myGrowthTip.id}
                      value={myGrowthTip.amount ?? 0}
                      onChange={(event) =>
                        setGrowthTips((prevGrowthSelectedTips) => {
                          //console.log('this is my prevGrowht Selected tips ---->', prevGrowthSelectedTips);
                          const updatedGrowthSelectedTips = prevGrowthSelectedTips.map((tip) => ({ ...tip }));
                          updatedGrowthSelectedTips[i].amount = convertToNumber(event.target.value);

                          return updatedGrowthSelectedTips;
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs className={styles.quantityButtons}>
                    <Tooltip title='Add Quantity'>
                      <span>
                        <IconButton disabled={!myGrowthTip.id} className={styles.quantityButton} onClick={() => addTipCountGrowth(i)}>
                          <AddCircleOutlineIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid item xs className={`${styles.tipPriceGrid} ${styles.price}`}>
                  <TipPriceTextField
                    disabled={!myGrowthTip.id}
                    value={convertToCurrency(myGrowthTip.treatmentPrice) ?? 0}
                    onChange={(event) =>
                      setGrowthTips((prevSelectedTips) => {
                        const updatedSelectedTips = [...prevSelectedTips];
                        updatedSelectedTips[i].treatmentPrice = convertToNumber(event.target.value);
                        return updatedSelectedTips;
                      })
                    }
                  />
                  {/* ${myGrowthTip.treatmentPrice ? convertToCurrency(myGrowthTip.treatmentPrice) : 0} */}
                </Grid>
                <Grid item className={`${styles.tipPriceGrid} ${styles.price}`}>
                  ${convertToCurrency(consumablePriceGrowth(i))}
                </Grid>
                <Grid item xs className={`${styles.tipPriceGrid}`}>
                  <TipPriceTextField
                    disabled={!myGrowthTip.id}
                    value={myGrowthTip.other ?? 0}
                    onChange={(event) =>
                      setGrowthTips((prevSelectedTips) => {
                        const updatedSelectedTips = [...prevSelectedTips];
                        updatedSelectedTips[i].other = convertToNumber(event.target.value);
                        return updatedSelectedTips;
                      })
                    }
                  />
                </Grid>
              </Grid>
            ))
          : 'Please Select A Machine'}
      </Grid>
    </Grid>
  );
}

export default withTranslation()(TipSelectGrowth);
